import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6l16 0","key":"svg-0"}],["path",{"d":"M4 12l10 0","key":"svg-1"}],["path",{"d":"M4 18l14 0","key":"svg-2"}]]

/**
 * IconAlignLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYWxpZ24tbGVmdCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNCA2bDE2IDAiIC8+CiAgPHBhdGggZD0iTTQgMTJsMTAgMCIgLz4KICA8cGF0aCBkPSJNNCAxOGwxNCAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/align-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconAlignLeft = createReactComponent('outline', 'align-left', 'AlignLeft', __iconNode);

export default IconAlignLeft;